import React from 'react'

import { MainWrapper } from './Header/style'
import EventDraft from '../EventDraft'
import DraftHeader from './Header'

const Drafts = () => {
  return (
      <MainWrapper column>
        <DraftHeader />
        <EventDraft />
      </MainWrapper>
  )
}
export default Drafts
